import React from 'react';

import { PorterFootprints } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/PorterFootprints.module.scss';

interface PorterFootprintsCmpProps {
  porter_footprints_data: PorterFootprints;
}

function PorterFootprintsCmp({
  porter_footprints_data,
}: PorterFootprintsCmpProps): React.ReactElement {
  return (
    <div className={styles['container']}>
      <h2 className={styles['main-title']}>
        {porter_footprints_data.text.text}
      </h2>
      <div className={styles['growth-container']}>
        {porter_footprints_data.achievements.map((data, index) => (
          <div className={styles['growth-item']} key={index}>
            <div className={styles['growth-title']}>{data.text}</div>
            <div className={styles['growth-desc']}>{data.sub_text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PorterFootprintsCmp;
